import { render, staticRenderFns } from "./AdditionalCategories.vue?vue&type=template&id=6a8e5fac&scoped=true&"
import script from "./AdditionalCategories.vue?vue&type=script&lang=js&"
export * from "./AdditionalCategories.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalCategories.vue?vue&type=style&index=0&id=6a8e5fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8e5fac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VChip,VDialog,VIcon})
